import React from 'react'
import { observer } from 'mobx-react-lite';
import { useStore } from '../../contexts/store'
import dayjs from 'dayjs'

import { useTranslation } from 'react-i18next'

import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Badge, BadgeOrigin, Box, Button } from '@mui/material';

import { useLocation } from 'wouter'
import { env } from '../../api/api';


const SyncStatus = ({style}:{ style?:any }) => {
  const { uiStore, broadcastStore, opStore, uploadStore } = useStore()
  const [ blockUnload, setBlockUnload ] = React.useState<boolean>(false)
  const { t } = useTranslation()

  const reportMode: "plain" | "verbose" = env.dev ? 'verbose' : 'plain'

  const badgeAnchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  } as BadgeOrigin

  const clientQueueLength = opStore.static.queue.length ? opStore.static.queue.length : 0
  const { syncQueueLength, lastSyncTimestamp, lastSyncStatus } = broadcastStore.serviceWorkerStatus
  const timeSinceLastSync = dayjs().unix() - lastSyncTimestamp

  var badgeInfo:string|number = syncQueueLength
  if (reportMode === 'verbose') badgeInfo = `${clientQueueLength}/${syncQueueLength}`

  var badgeColor: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"
  badgeColor = 'default'

  var title = t('SHRIMP_PODS is online.')
  var connectivityIcon = <WifiIcon fontSize='small' />

  if (uiStore.isOffline) {
    title = t('SHRIMP_PODS is offline.')
    connectivityIcon = <WifiOffIcon fontSize='small' />
  }

  if (lastSyncStatus !== 200) {
    badgeColor = 'warning'
    title += ' ' + t('The last sync failed with status {{lastSyncStatus}}.', {lastSyncStatus})
    if (badgeInfo === 0) badgeInfo = '!'
  }

  if ((lastSyncTimestamp < 1600000000) && (syncQueueLength)) {
    badgeColor = 'warning'
    title += ' ' + t('You have not yet successfully synced. You should go online soon!')
  } else if ((timeSinceLastSync > 3600) && (syncQueueLength)) {
    badgeColor = 'warning'
    title += ' ' + t('The last successful sync was more than {{count}} hours ago. You should go online soon!', {count: Math.floor(timeSinceLastSync/3600)})
  }

  if (syncQueueLength) title += ' ' + t('You currently have {{count}} unsynced changes.', {count: syncQueueLength})

  if ((clientQueueLength > 15) || ((clientQueueLength>0) && (opStore.static.queue[0].tCreated) && ((dayjs().unix() - opStore.static.queue[0].tCreated) > 30))) {
    badgeColor = 'error'
    title += "\n" + t('ATTENTION: Your edits are not being saved.')
  }

  if ((clientQueueLength || syncQueueLength) && (!blockUnload)) {
    setBlockUnload(true)
    window.addEventListener('beforeunload', opStore.onUnload, true)
  }
  if (!(clientQueueLength || syncQueueLength) && (blockUnload)) {
    setBlockUnload(false)
    window.removeEventListener('beforeunload', opStore.onUnload, true)
  }

  const badgeIcon = <Badge
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    slotProps={{badge: {style:{fontSize:'10px'} }}}
    color='secondary'
    badgeContent={uploadStore.status === 'uploading' ? uploadStore.uploadQueue.length : null}
    max={9}
  >
    <Badge anchorOrigin={badgeAnchorOrigin} color={badgeColor} badgeContent={badgeInfo} slotProps={{badge: {style:{fontSize:'10px'} }}} max={99}>
      {connectivityIcon}
    </Badge>
  </Badge>

  const navigate = useLocation()[1]
  const onClick = () => { navigate('/syncing', {state: {prevUrl: window.location.pathname}}) }
  const basicStyle = {
    opacity: (badgeColor === 'default') ? .5 : 1,
    backgroundColor: (badgeColor === 'default') ? 'none' : '#fff',
    marginRight:8,
    color:'#000',
    ...style,
  }

  return <Button onClick={onClick} style={basicStyle} title={`${title}`}>
    {badgeIcon}
  </Button>
}

export default observer(SyncStatus)